import ReactDOM from 'react-dom/client';
import './Styles/style.scss';
import {App} from './App';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
